module.exports = __webpack_public_path__ + "static/media/97gal14.757e58d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/97gal/97gal14.jpg
// module id = 337
// module chunks = 0